import { connect } from 'react-redux';
import { getChatPanelOpen, getChatUnreadCount } from '../../../Chat/redux/selectors';
import { openChatPanel, closeChatPanel } from '../../../Chat/redux/actions';
import { getNotesCount } from '../../../publicSession/selectors';
const mapStateToProps = (state)=>({
        isOpen: getChatPanelOpen(state),
        chatCount: getChatUnreadCount(state) + getNotesCount(state)
    });
const mapDispatchToProps = {
    onOpen: openChatPanel,
    onClose: closeChatPanel
};
export default connect(mapStateToProps, mapDispatchToProps);
